var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderQr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 529",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 169",
    d: "M11.212 42.775h1.708c.008-.182.023-.353.023-.524v-6.082c0-.78.274-1.058 1.044-1.061h2.238c.693 0 1 .315 1 1.017q.006 3.041 0 6.082v.559H18.9c.012-.194.033-.381.033-.567v-6.082a.9.9 0 0 1 .578-.967c.6-.218 1.131.22 1.133.928V42.8c.881 0 1.719-.009 2.556 0a.841.841 0 0 1 .138 1.675 4.146 4.146 0 0 1-.486.009H.96a.825.825 0 0 1-.876-.838.808.808 0 0 1 .869-.846c.825-.013 1.65 0 2.529 0 .009-.2.024-.374.024-.545v-6.082c0-.78.276-1.061 1.042-1.065h2.238c.7 0 1 .31 1 1.013q.005 3.041 0 6.081v.562h1.69c.011-.175.033-.36.034-.545v-6.13c0-.561.247-.895.688-.97a.847.847 0 0 1 1.008.938v6.717",
    transform: "translate(-.079 -31.679)",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 170",
    d: "M136.471 152.3v1.993a.87.87 0 0 1-.977.994c-.794.006-1.588.008-2.381 0a.831.831 0 0 1-.926-.932q-.009-2.041 0-4.082c0-.64.313-.941.962-.946.794-.006 1.588-.007 2.381 0a.851.851 0 0 1 .939.933c.011.68 0 1.361 0 2.041",
    transform: "translate(-119.318 -134.791)",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 171",
    d: "M35.221 152.292c0-.68-.006-1.361 0-2.041a.835.835 0 0 1 .929-.932q1.215-.012 2.43 0a.845.845 0 0 1 .923.945q.011 2.041 0 4.082a.843.843 0 0 1-.936.932q-1.215.014-2.43 0a.835.835 0 0 1-.915-.944c-.006-.68 0-1.361 0-2.041",
    transform: "translate(-31.791 -134.782)",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 172",
    d: "M1.7 1.737v2.4c0 .655-.3 1.011-.846 1.011S.01 4.791.008 4.137Q0 2.583.008 1.029c0-.68.3-.981.972-.986q1.6-.012 3.205 0a.851.851 0 1 1 .006 1.692c-.807.006-1.613 0-2.489 0",
    transform: "translate(-.004 -.033)",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 173",
    d: "M197.806 1.7c-.891 0-1.731.038-2.564-.022a1.075 1.075 0 0 1-.753-.473 1 1 0 0 1 .072-.842.94.94 0 0 1 .69-.343A86.967 86.967 0 0 1 198.6.012a.818.818 0 0 1 .9.914q.014 1.651 0 3.3a.846.846 0 1 1-1.689-.006c-.01-.821 0-1.643 0-2.52",
    transform: "translate(-175.506)",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 174",
    d: "M1.7 196.727h2.439c.61 0 .978.311.993.822s-.368.868-1 .872q-1.578.009-3.157 0c-.673-.005-.971-.309-.974-.986q-.009-1.578 0-3.157c0-.613.319-.963.846-.963s.843.35.847.961c.005.791 0 1.582 0 2.451",
    transform: "translate(0 -174.503)",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 175",
    d: "M197.32 196.726v-2.4c0-.658.3-1.01.845-1.011s.846.356.849 1.01q.006 1.554 0 3.109c0 .678-.3.982-.973.987q-1.6.012-3.206 0a.851.851 0 0 1-.947-.87.842.842 0 0 1 .943-.822c.807-.006 1.614 0 2.489 0",
    transform: "translate(-175.02 -174.502)",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 176",
    d: "M195.481 152.345v2.041a.856.856 0 1 1-1.7.01q-.016-2.041 0-4.082a.839.839 0 0 1 .872-.945c.519.012.829.372.833.983v1.993",
    transform: "translate(-174.911 -134.834)",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 177",
    d: "M98.609 152.364c0 .68.005 1.361 0 2.041a.85.85 0 1 1-1.694.027q-.015-2.089 0-4.178a.814.814 0 0 1 .831-.881.829.829 0 0 1 .861.9c.01.7 0 1.393 0 2.089",
    transform: "translate(-87.476 -134.837)",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 178",
    d: "M23.27 115.938H.887a.8.8 0 0 1-.8-.8v-.091a.8.8 0 0 1 .8-.8H23.27a.8.8 0 0 1 .8.8v.091a.8.8 0 0 1-.8.8",
    transform: "translate(-.079 -103.13)",
    style: {
      fill: "#7833ba"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderQr);
export default __webpack_public_path__ + "static/media/header_qr.3f243bef9bc3f0691eef784e32e88173.svg";
export { ForwardRef as ReactComponent };